// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26H-X","rightAdornment":"Header_rightAdornment__24ybK"};